'use client';

import { copy } from '@/data/copy';
import { cn } from '@/lib/utils';
import { CircleArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';

type BackToPreviousPageProps = {
  className?: string;
};

export default function BackToPreviousPage({
  className,
}: BackToPreviousPageProps) {
  const router = useRouter();

  return (
    <span
      className={cn(
        'text-xl text-gray-500 hover:text-gray-700 dark:text-bodydark1 font-bold cursor-pointer flex items-center gap-2 w-max',
        className
      )}
      onClick={() => {
        router.back();
      }}
    >
      <CircleArrowLeft /> {copy.common.backToPreviousPage}
    </span>
  );
}
